import { search } from "../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);

const path = `${process.env.REACT_APP_URL_API_REPORTS}/customerranking`;
const documentsHubPath = `${process.env.REACT_APP_URL_API_DOC_HUB}/reports`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findCustomerRanking(filterProps) {
  const url = new URL(path);
  Object.entries(filterProps).forEach(([key, value]) => {
    if (value) {
      url.searchParams.append(key, value);
    }
  });

  return search(decodeURIComponent(url), "GET", headers);
}

export async function printCustomerRankingPDF(body) {
  const url = `${documentsHubPath}/customer-ranking/generate`;

  return search(`${url}`, "POST", headers, body);
}
